import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import type { ArticleV1 } from '@ilteducation/content-registry-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticlesWithSyntheticAudioDataTable',
  setup(__props, { expose }) {

const PER_PAGE = 100;

const articleListUrl = process.env.VUE_APP_ARTICLES_API_URL_LIST;
const allSyntheticArticles = ref<ArticleV1[]>([]);
const selectedArticles = ref<ArticleV1[]>([]);
const loading = ref(false);
const search = ref('');

expose({ selectedArticles });

const fetchAllSyntheticArticles = async () => {
  loading.value = true;
  allSyntheticArticles.value = [];
  let page = 1;
  let fetched = 0;
  let total = Infinity;

  try {
    while (fetched < total) {
      const params = new URLSearchParams({
        sort: 'lastUpdatedAt:desc',
        filter: 'exists:audio',
        'pagination[page]': String(page),
        'pagination[perPage]': String(PER_PAGE),
      });
      const response = await axios.get(`${articleListUrl}?${params}`);
      const data = response.data;
      total = data.total ?? 0;
      const batch: ArticleV1[] = data.data ?? [];
      fetched += batch.length;
      const synthetic = batch.filter((article) =>
        Object.values(article.audio!).some((audioItem: any) => audioItem.sourceType === 'synthetic'),
      );
      allSyntheticArticles.value.push(...synthetic);
      if (batch.length < PER_PAGE) break;
      page++;
    }
  } catch (error) {
    console.error('Error fetching articles with synthetic audio:', error);
  } finally {
    loading.value = false;
  }
};

onMounted(fetchAllSyntheticArticles);

const filteredArticles = computed(() => {
  const q = search.value.trim().toLowerCase();
  if (!q) return allSyntheticArticles.value;
  return allSyntheticArticles.value.filter(
    (a) =>
      a.headline?.toLowerCase().includes(q) ||
      a.author?.toLowerCase().includes(q) ||
      a.publisher?.toLowerCase().includes(q),
  );
});

const headers = [
  { text: 'ID', value: 'id' },
  { text: 'Headline', value: 'headline' },
  { text: 'Author', value: 'author' },
  { text: 'Publisher', value: 'publisher' },
  { text: 'Audio', value: 'audio' },
  { text: 'Created', value: 'createdAt' },
];

return { __sfc: true,PER_PAGE, articleListUrl, allSyntheticArticles, selectedArticles, loading, search, fetchAllSyntheticArticles, filteredArticles, headers }
}

})